import { GridCellProps } from '@progress/kendo-react-grid';
import { useTranslation } from 'react-i18next';
import NoItemIcon from 'src/assets/icons/NoItemIcon';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { useContextSelector } from 'use-context-selector';
import { ViewCatalogProductsContext } from '../ViewCatalogProductsContext';

const SwapItem = (props: GridCellProps) => {
  const { t } = useTranslation();
  const { value } = useGridCellDisplayValue(props);
  const setIsSwapItemModalOpen = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.setIsSwapItemModalOpen
  );
  const setSwapItemData = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.setSwapItemData
  );

  const handleSwapItemClick = (
    event: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>
  ) => {
    event.stopPropagation();
    event.preventDefault();
    setIsSwapItemModalOpen(true);
    setSwapItemData({
      pageType: 4,
      supplierId: props.dataItem?.supplierId,
      supplierCompanyId: props.dataItem?.supplierCompanyId,
      itemNumber: props.dataItem?.itemNum,
      productId: props.dataItem?.productId,
      catalogId: props.dataItem?.catalogId,
      categoryId: props.dataItem?.categoryId,
      quantity: props.dataItem?.qty,
      price: Number(props.dataItem?.price),
      uom: props.dataItem?.uom,
    });
  };
  const showSwapIcon = Boolean(value);

  return (
    <GridCellBase
      {...props}
      disableToolTip={!showSwapIcon}
      title={showSwapIcon ? t('Check Contracted Alternatives') : undefined}
    >
      {showSwapIcon ? (
        <div
          onClick={handleSwapItemClick}
          className="flex items-center justify-center cursor-pointer"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              handleSwapItemClick(event);
            }
          }}
        >
          <NoItemIcon />
        </div>
      ) : (
        <></>
      )}
    </GridCellBase>
  );
};

export default SwapItem;
